import { useNavigate } from "react-router-dom";
import { Dialog } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { IncomingCallDetails } from "@/features/incomingCall/IncomingCallDetails";
import { contactPathForMatch, type IncomingCallNotice } from "@/features/incomingCall/incomingCall";

export function IncomingCallModal({
  call,
  onDismiss,
}: {
  call: IncomingCallNotice | null;
  onDismiss: () => void;
}) {
  const navigate = useNavigate();
  const soleMatch = call?.matches.length === 1 ? call.matches[0] : undefined;
  const solePath = soleMatch ? contactPathForMatch(soleMatch) : null;

  function openContact(path: string) {
    onDismiss();
    navigate(path);
  }

  return (
    <Dialog
      open={call != null}
      onClose={onDismiss}
      title="Eingehender Anruf"
      description={call?.phone_display}
      size="sm"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onDismiss}>
            Schließen
          </Button>
          {solePath ? (
            <Button type="button" onClick={() => openContact(solePath)}>
              Kontakt öffnen
            </Button>
          ) : null}
        </>
      }
    >
      {call ? (
        <IncomingCallDetails
          matches={call.matches}
          onOpen={openContact}
          showOpen={call.matches.length !== 1}
        />
      ) : null}
    </Dialog>
  );
}
